import React, { useState, useEffect } from 'react';
import { Container } from '@mui/material';
import axios from 'axios';

import SERVER_API_URL from '../../../config';
import ChurchList from './ChurchList';

const Church = () => {
  const [churchList, setChurchList] = useState([]);

  useEffect(() => {
    const getAllChurch = async () => {
      try {
        const response = await axios.get(`${SERVER_API_URL}/landing/getChurchInfo`);

        if (response.status === 200) {
          setChurchList(response.data);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    getAllChurch();
  }, []);

  return (
    <>
      <Container sx={{ py: { xs: 6, sm: 10 } }} maxWidth="lg">
        <ChurchList churchList={churchList} />
      </Container>
    </>
  );
};

export default Church;
